import React, { useCallback, useEffect, useRef, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Grid, Stack } from "@mui/material";
import OgmDashboardCardView from "./OgmDashboardCardView";
import { useNavigate } from "react-router-dom";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import { clearData, getOGMDashboardCounts } from "../../../redux/features/OgdDashboard";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { DashboardCountCardSkeleton } from "../hrDashboard/CardViewComponents";
import dayjs from "dayjs";
import TotalNoOfReports from "./TotalNoOfReports";
import useResponsive from "../../../Hooks/useResponsive";
import GlobalSelectFieldWithoutFormikNew from "../../../components/mui/GlobalSelectFieldWithoutFormikNew";
 const selectionData = [
  { id: 1, value: "None" },
  { id: 2, value: "Assessment Based" },
];
const OgmDashboard = () => {
  const [fromDate, setFromDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD")
  ); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [direction, setDirection] = useState("row");
  const smDown = useResponsive("down", "sm");
  useEffect(() => {
    if (smDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [smDown]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fromDateRef = useRef(fromDate); //USING USEREF BECAUSE WHILE USING USECALBACK INORDER TO PROVIDE UN WANTED RE RENDER
  const toDateRef = useRef(toDate);

  const { loading, resData } = useSelector((store) => store.ogdDashboard);
  const { data, meta } = resData;
  const [selectedDateCriteria, setSelectedDateCriteria] = useState( { id: 1, value: "None" });

  useEffect(() => {
    //GETTING THE OGD DASHBOARD COUNTS INITIAL AND WHILE CHANGING THE FROM AND TO DATE
    dispatch(getOGMDashboardCounts({ fromDate, toDate, selectedDateCriteria }));
    return(()=>{
    dispatch(clearData())
      
    })
  }, [fromDate, toDate, selectedDateCriteria]);

  useEffect(() => {
    //IT CAN AVOID RE RENDER
    fromDateRef.current = fromDate;
    toDateRef.current = toDate;
  }, [fromDate, toDate]);

  const clickFunction = useCallback((sogoId) => {
    const fromDateValue = fromDateRef.current;
    const toDateValue = toDateRef.current;
    //WHEN THE CARD CLICKS THEN IT WILL NAVIGATE TO THE SOGO DASHBOARD
    navigate(
      `/dashboard/sogo-assessment/?${sogoId ? `sogoId=${sogoId}` : ""}${
        fromDateValue ? `&fromDate=${fromDateValue}` : ""
      }${toDateValue ? `&toDate=${toDateValue}` : ""}&filterCriteria=${
        selectedDateCriteria?.id
      }`
    );
  }, [selectedDateCriteria]);

  const UnconfirmedNavigation = () => {
    // alert("It will navigate");
    navigate(`/my-workspace/assessment-dashboard?fromDate=${fromDateRef.current}&toDate=${toDateRef.current}`);
  };

  return (
    <GlobalWrapper title="OGM Dashboard">
      <Box>
        <Stack direction={direction} gap={1} mb={1}>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
          <GlobalSelectFieldWithoutFormikNew
            keys={{ itemId: "id", itemValue: "value" }}
            data={selectionData}
            label={"Filter Criteria"}
            fullWidth={true}
            selectedDetails={selectedDateCriteria}
            setChange={setSelectedDateCriteria}
          />
        </Stack>

        {!loading && (
          <TotalNoOfReports
            assessmentTaken={data?.headData?.[0]?.totalAssessmentCount}
            reportGenerated={data?.headData?.[0]?.totalReportCount}
            totalCourseEnrollmentCount={data?.headData?.[0]?.totalCourseEnrollmentCount}
            totalAdmissionCount={
              data?.headData?.[0]?.totalAdmissionCount
            }
            totalArpu={data?.headData?.[0]?.totalArpu}
            totalAcr={data?.headData?.[0]?.totalAcr}
            totalTar={data?.headData?.[0]?.totalTar}
            totalSfr={data?.headData?.[0]?.totalSfr}
            top={data?.headData?.[0]?.topUserNames}
            saleAmount={data?.headData?.[0]?.totalTotalFees}
            revenue={data?.headData?.[0]?.totalRevenue}
            admissionNotConfirmed={data?.headData?.[0]?.totalUnenrolledCount}
            navigateFunction={UnconfirmedNavigation}
          />
        )}

        <Box mt={2}>
          <Grid container spacing={4}>
            {loading ? ( //CARD SKELETON WHILE LOADING
              <DashboardCountCardSkeleton />
            ) : (
              <>
                {data?.userData?.length > 0 && //MAKE SURE THE CARDS DATA COMES AND ONLY DISPLAYING AFTER IT COMES
                  data?.userData.map((card, index) => (
                    <Grid item xs={12} sm={6} md={4} key={card.userId}>
                      <OgmDashboardCardView
                        name={card.userName}
                        userId={card.userId}
                        assessmentTaken={card.assessmentCount}
                        assessmentReportGenerated={card.reportCount}
                        color="#7054eb"
                        clickFunction={clickFunction}
                        delay={index * 0.2}
                        admissinCount={card.admissionCount}
                        courseEnrollment={card.courseEnrollmentCount}
                        admissinUnconfirmed={card.unenrolledCount}
                        revenue={card.revenue}
                        saleAmount={card.totalFees}
                        tar={card.tar}
                        sfr={card.sfr}
                        acr={card.acr}
                        arpu={card.arpu}
                      />
                    </Grid>
                  ))}
              </>
            )}
          </Grid>
        </Box>
      </Box>
    </GlobalWrapper>
  );
};

export default OgmDashboard;
